import API from "../util/api";

export const getShippingCosts = async (params = {}) => {
  let data = null;

  await API.get('/shipping-costs', {params})
    .then(res => {
      data = res.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
};

export const storeShippingCost = async (payload) => {
  let data = null;

  await API.post('/shipping-costs', payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const updateShippingCost = async (id, payload) => {
  let data = null;

  await API.patch(`/shipping-costs/${id}`, payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const deleteShippingCost = async (payload) => {
  await API.delete('/shipping-costs/'+payload.id)
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return true;
}

